/**
 * Formats an action letter shortcut with ⇧ for keycaps.
 */
export function formatCommandBarActionShortcut(letter: string): string {
  const normalized = letter.trim().toUpperCase()
  if (!normalized) return letter

  return `⇧${normalized}`
}
